<template>
    <div class="modal fade" id="modal-edit-lot" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="modalEditLot" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5">จัดการล็อตสินค้า</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row" v-if="modalItem">
                        <div class="col-12 mb-3">
                            <h4 class="fw-bold text-primary">{{ modalItem.product_name }}</h4>
                        </div>
                        <div class="col-12">
                            <table class="table">
                                <tr>
                                    <th>เริ่มนับ</th>
                                    <th>ขายไป</th>
                                    <th>นับได้</th>
                                </tr>
                                <tr>
                                    <td>{{ formatNumber(modalItem.expected_qty, 0) }}</td>
                                    <td>
                                        {{
                                            formatNumber(
                                                modalItem.sold_qty_before_count +
                                                modalItem.sold_qty_after_count,
                                                0
                                            )
                                        }}
                                    </td>
                                    <td>{{ formatNumber(modalItem.counted_qty, 0) }}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-6">
                            <label>จัดการจำนวนสินค้า</label>
                            <tree-select :options="stockCountActions" :value="modalItem.selected_product_action_id"
                                :class="{ 'tree-select-error': showValidation && !modalItem.selected_product_action_id }"
                                @tree-select="(value) => $emit('select-product-action', modalItem.index, value)"
                                @de-select="$emit('select-product-action', modalItem.index, null)" />
                        </div>
                        <div class="col-6">
                            <div v-if="modalItem.selected_product_action_id == 4">
                                <label>ตั้งค่าเอง</label>
                                <input type="number" class="form-control form-control-sm"
                                    v-model="modalItem.action_manual" />
                            </div>
                        </div>
                    </div>

                    <div class="col-12" style="max-height: 350px; overflow-y: auto">
                        <div class="my-3">
                            <button type="button" class="btn btn-success btn-sm" @click="$emit('add-new-lot')">
                                <i class="fas fa-plus"></i> เพิ่มล็อตใหม่
                            </button>
                        </div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>เลขล็อต</th>
                                    <th>วันหมดอายุ</th>
                                    <th>จำนวนในคลัง</th>
                                    <th width="250px">จัดการ</th>
                                    <th>ปรับเป็น</th>
                                    <th width="100px">รายละเอียด</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in selectedLots" :key="i" :class="{
                                    'table-success': item.is_new_lot,
                                    'table-danger': !item.is_new_lot,
                                }">
                                    <td v-if="item.is_new_lot">
                                        <input type="text" class="form-control form-control-sm"
                                            v-model="item.manufacturing_no" placeholder="เลขล็อต" />
                                    </td>
                                    <td v-else>{{ item.manufacturing_no }}</td>
                                    <td v-if="item.is_new_lot">
                                        <input type="date" class="form-control form-control-sm"
                                            v-model="item.expiry_date" />
                                    </td>
                                    <td v-else>
                                        <span>
                                            {{
                                                item.expiry_date
                                                    ? format_thai_date(item.expiry_date)
                                                    : 'ไม่ระบุ'
                                            }}
                                        </span>
                                    </td>
                                    <td v-if="item.is_new_lot">
                                        <span>0</span>
                                    </td>
                                    <td v-else>{{ item.remaining_amount }}</td>
                                    <td>
                                        <tree-select :options="stockCountLotActions"
                                            :value="item.selected_product_action_id"
                                            :class="{ 'tree-select-error': showValidation && !item.selected_product_action_id }"
                                            @tree-select="(value) => $emit('select-lot-action', i, value)"
                                            @de-select="$emit('select-lot-action', i, null)" />
                                    </td>
                                    <td v-if="item.selected_product_action_id == 4">
                                        <input type="number" class="form-control form-control-sm"
                                            v-model="item.action_manual" />
                                    </td>
                                    <td v-else>
                                        <span v-if="item.selected_product_action_id">
                                            {{ item.selected_product_action_name }}({{
                                                get_qty_by_action(item) ?? 0
                                            }})
                                        </span>
                                        <span v-else>ยังไม่แก้ไข</span>
                                    </td>
                                    <td>
                                        <button v-if="item.is_new_lot" type="button" class="btn btn-danger btn-sm"
                                            @click="$emit('remove-lot', i)">
                                            <i class="fas fa-trash"></i>
                                        </button>
                                        <button v-if="!item.is_new_lot && modalItem.selected_product_action_id"
                                            type="button" class="btn btn-info btn-sm"
                                            @click="$emit('view-lot-transactions', item)"
                                            title="ดูรายละเอียด Stock Transactions">
                                            <i class="fas fa-info-circle"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="px-3">
                    <div class="d-flex align-items-center gap-2">
                        <div class="alert alert-info mt-2 flex-grow-1" v-if="modalItem">
                            <small>
                                <strong>ผลรวมล็อต:</strong> {{ getSumLotQty(selectedLots) }} |
                                <strong>จำนวนสินค้า:</strong> {{ getProductQty(modalItem) }}
                                <span v-if="getSumLotQty(selectedLots) != getProductQty(modalItem)" class="text-danger">
                                    (ไม่ตรงกัน)
                                </span>
                                <span v-else class="text-success"> (ตรงกัน) </span>
                            </small>
                        </div>
                        <button type="button" class="btn btn-primary" @click="handleConfirm">
                            ยืนยัน
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StockCountEditLotModal',

    props: {
        modalItem: {
            type: Object,
            default: null,
        },
        selectedLots: {
            type: Array,
            default: () => [],
        },
        stockCountActions: {
            type: Array,
            default: () => [],
        },
        stockCountLotActions: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            modal: null,
            showValidation: false,
        };
    },

    mounted() {
        this.modal = new bootstrap.Modal(this.$refs.modal, {});
    },

    methods: {
        show() {
            this.showValidation = false;
            this.modal.show();
        },

        hide() {
            this.showValidation = false;
            this.modal.hide();
        },

        handleConfirm() {
            // ตรวจสอบว่า product action ถูกเลือกหรือยัง
            const isProductActionSelected = this.modalItem && this.modalItem.selected_product_action_id;

            // ตรวจสอบว่าทุก lot ถูกเลือก action หรือยัง
            const allLotsSelected = this.selectedLots.every(lot => lot.selected_product_action_id);

            if (!isProductActionSelected || !allLotsSelected) {
                this.showValidation = true;
                return;
            }

            this.showValidation = false;
            this.$emit('confirm');
        },

        formatNumber(n, dec = 2) {
            return new Intl.NumberFormat('us-US', {
                minimumFractionDigits: dec,
                maximumFractionDigits: dec,
            }).format(n);
        },

        format_thai_date(date) {
            return window.format_thai_date(date);
        },

        get_qty_by_action(item) {
            let amount = 0;
            if (item.selected_product_action_id == 1) {
                amount = item.expected_qty;
            } else if (item.selected_product_action_id == 2) {
                amount =
                    Number(item.expected_qty) -
                    (Number(item.sold_qty_before_count) + Number(item.sold_qty_after_count));
            } else if (item.selected_product_action_id == 3) {
                amount = item.counted_qty;
            } else if (item.selected_product_action_id == 4) {
                amount = Number(item.action_manual);
            } else if (item.selected_product_action_id == 5) {
                amount =
                    item.counted_qty -
                    Number(item.sold_qty_before_count) +
                    Number(item.sold_qty_after_count);
            } else if (item.selected_product_action_id == 6) {
                amount = item.remaining_amount;
            }
            return amount;
        },

        getProductQty(product) {
            if (!product) return 0;
            let sumProduct = product.counted_qty;
            if (product.selected_product_action_id == 1) {
                sumProduct = product.expected_qty;
            } else if (product.selected_product_action_id == 2) {
                sumProduct =
                    product.expected_qty -
                    Number(product.sold_qty_before_count) +
                    Number(product.sold_qty_after_count);
            } else if (product.selected_product_action_id == 3) {
                sumProduct = product.counted_qty;
            } else if (product.selected_product_action_id == 4) {
                sumProduct = product.action_manual;
            } else if (product.selected_product_action_id == 5) {
                sumProduct =
                    product.counted_qty -
                    Number(product.sold_qty_before_count) +
                    Number(product.sold_qty_after_count);
            }
            return sumProduct;
        },

        getSumLotQty(lots) {
            return lots.reduce((sum, item) => {
                const amount = this.get_qty_by_action(item);
                return Number(amount) + Number(sum);
            }, 0);
        },
    },
};
</script>

<style scoped>
.tree-select-error ::v-deep .vue-treeselect__control {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
</style>
